import { useMutation } from "react-query";
import { updateJob } from "../../../../actions/Utilities/JobConfig";

const useEditJobs = () => {
  return useMutation(updateJob);
};

export default useEditJobs;
